import React, { useEffect, useState } from 'react';

import {
  Select,
} from '@mui/material';

import MenuItem from '@mui/material/MenuItem';

import brazil from '../../../assets/brazil_flags.svg';
import portugal from '../../../assets/portugal_flags.svg';
import spain from '../../../assets/spain_flags.svg';
import mexico from '../../../assets/mx_flags.svg';
import gb from '../../../assets/gb_flags.svg';
import us from '../../../assets/us_flags.svg';
import MenuBody from '../../../components/MenuItem';


const LanguageSelection = (props) => {

  const [flag, setFlag] = useState(brazil)
  const [isOpen, setIsOpen] = useState(false)
  const [language, setLanguage] = useState(localStorage.getItem('i18nextLng'));
  const [icon, setIcon] = useState();

  useEffect(() => {
    if(localStorage.getItem('i18nextLng') === 'pt-BR') {
      setFlag(brazil)
    } else if (localStorage.getItem('i18nextLng') === 'esp-ES') {
      setFlag(spain)
    } else {
      setFlag(gb)
    }
    setIcon(localStorage.getItem('i18nextLng'))
  }, [])

  const handleLanguage = (event) => {
    setLanguage(event.target.value);
    if (event.target.value === 'pt-BR') {
      setFlag(brazil)
    } else if (event.target.value === 'esp-ES') {
      setFlag(spain)
    } else {
      setFlag(gb)
    }
    localStorage.setItem('i18nextLng',event.target.value)
    window.location = window.location;
  }

  const handleClick = (e) => {
    setIsOpen(false)
    e.stopPropagation();
    window.location = window.location
  };

  return (
    <div style={{...styles.IconImgContainer, ...props.sx}}>
      <img src={flag} style={styles.IconImg} alt='flag'/>
      <Select
        variant="standard"
        style={styles.selectLanguage}
        onClose={(e) => handleClick(e)}
        onOpen={() => setIsOpen(true)}
        value={language}
        onChange={handleLanguage}>
        <MenuItem value={'pt-BR'} style={icon === 'pt-BR'? styles.selected : styles.none}>
          <MenuBody
            title="Português"
            isOpen={isOpen}
            flag={brazil}
            flag2={portugal}
            icon={icon}
            idiom="pt-BR"
          />
        </MenuItem>
        <MenuItem value={'esp-ES'} style={icon === 'esp-ES'? styles.selected : styles.none}>
          <MenuBody
            title="Español"
            isOpen={isOpen}
            flag={spain}
            flag2={mexico}
            icon={icon}
            idiom="esp-ES"
          />
        </MenuItem>
        <MenuItem value={'en-US'} style={icon === 'en-US'? styles.selected : styles.none}>
          <MenuBody
            title="English"
            isOpen={isOpen}
            flag={us}
            flag2={gb}
            icon={icon}
            idiom="en-US"
          />
        </MenuItem>
      </Select>
    </div>
  );
}

const styles = {
  IconImgContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 20,
    top: 20,
  },
  IconImg:{
    maxWidth: '2rem',
    height: '2rem',
    marginLeft: '20px',
    paddingRight: '5px'
  },
  selected: {
    width: '210px',
    display: 'flex',
    borderRadius: '7px',
    color: '#000',
    justifyContent: 'space-between'
  },
  selectLanguage: {
    color: '#000'
  },
  none: {
    borderRadius: '7px',
    display: 'flex',
    width: '210px',
    justifyContent: 'space-between'
  },
  appBar: {
    backgroundColor: 'green',
    height: '65px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}

export default LanguageSelection;
